import {gql} from '@apollo/client';

export default gql`
  mutation attributionRun($input: AttributionRunInput!) {
    authed {
      success
    }
    attributionRun(input: $input) {
      success
    }
  }
`;
